<script>
  export let product;
  export let gallery;
</script>
<div
  class="mbox"
  style={`order: ${product.order}`}
  key={product.key}
  data-rel={gallery}
  data-src={`/images/zoom--${product.key}-3000.jpg`}
  data-type="image"
  data-title={product.name}
>
  <img
    class="thumbnail"
    alt="image"
    srcset={`
             ./images/thumbnail--${product.key}-120.jpg 120w,
             ./images/thumbnail--${product.key}-240.jpg 240w,
             ./images/thumbnail--${product.key}-375.jpg 375w,
             ./images/thumbnail--${product.key}-512.jpg 512w,
             `}
    src={`./images/thumbnail--${product.key}-120.jpg`}
  />
</div>
<style>
  .mbox {
    flex-basis: 50%;
  }
  .thumbnail {
    width: 100%;
    display: block;
    cursor: zoom-in;
  }
  @media screen and (min-width: 480px) {.mbox {flex-basis: calc(100% / 3);}}
  @media screen and (min-width: 640px) {.mbox {flex-basis: calc(100% / 4);}}
  @media screen and (min-width: 720px) {.mbox {flex-basis: calc(100% / 5);}}
</style>
